import {all} from 'redux-saga/effects'
import {reviewSaga} from "../review/review.saga";
import {cardEditorSaga} from "../cards/editor/cardEditor.saga";
import {addCardSaga} from "../cards/add/addCard.saga";
import {authSaga} from "../auth/auth.saga";
import {searchSaga} from "../cards/search/search.saga";
import {cardDownloaderSaga} from "../cards/downloader/cardDownloader.saga";
import {deleteCardSaga} from "../cards/delete/deleteCard.saga";
import {moveToStateSaga} from "../cards/moveToState/moveToState.saga";
import {addTagSaga} from "../cards/addTag/addTag.saga";
import {regenerateCardSaga} from "../cards/regenerate/regenerateCard.saga";
import {invertCardSaga} from "../cards/invert/invertCard.saga";
import {revertCardSaga} from "../cards/revert/revertCard.saga";
import {cardGenerationSaga} from "../cards/generation/cardGeneration.saga";
import {quickAddSaga} from "../cards/quickAdd/quickAdd.saga";
import {markCardSaga} from "../cards/mark/markCard.saga";

export function* rootSaga() {
    yield all([
        addCardSaga(),
        addTagSaga(),
        authSaga(),
        cardDownloaderSaga(),
        cardEditorSaga(),
        cardGenerationSaga(),
        deleteCardSaga(),
        invertCardSaga(),
        markCardSaga(),
        moveToStateSaga(),
        quickAddSaga(),
        regenerateCardSaga(),
        revertCardSaga(),
        reviewSaga(),
        searchSaga(),
    ]);
}
